module.exports = __webpack_public_path__ + "files/77abaea3b844a91e8d563b7c1cd4eca4.svg";